export default "__VITE_ASSET__CAxlGog9__"